import { render } from "./PdfCartaPropostaQuantidadePreco.vue?vue&type=template&id=96ad9470&scoped=true"
import script from "./PdfCartaPropostaQuantidadePreco.vue?vue&type=script&lang=js"
export * from "./PdfCartaPropostaQuantidadePreco.vue?vue&type=script&lang=js"

import "./PdfCartaPropostaQuantidadePreco.vue?vue&type=style&index=0&id=96ad9470&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ad9470"]])

export default __exports__